// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"2e1af144","247":"7f9d64db","513":"ba44ebd0","632":"6d90044b","706":"711ede07","726":"759a3e6d"}[chunkId] + ".chunk.js";
};